import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-flow-collapse-button',
  templateUrl: './flow-collapse-button.component.html',
})
export class FlowCollapseButtonComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams;

  displayChevron = false;

  collapsed = true;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.refreshState();
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.refreshState();
    return true;
  }

  toggleCollapse(): void {
    if (!this.displayChevron) {
      return;
    }
    // Delegates expand/collapse behavior to the parent list component.
    this.params.context.componentParent.toggleFlowGroup(
      this.params.data.displayId
    );
    this.refreshState();
  }

  private refreshState(): void {
    // Computes chevron visibility and current collapsed/expanded icon state.
    const { context } = this.params;
    this.displayChevron = !!context.isFlowGroupExpandable?.(this.params.data);
    this.collapsed = !context.isFlowGroupExpanded?.(
      this.params.data?.displayId
    );
  }
}
